import React from 'react'
const Error = () => {
  return (
    <div className="section section-center text-center">
      <h2>Error...Please try again</h2>
    </div>
  )
}

export default Error
